<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productTrackingCodes"
  >
    <blockquote class="quote quote-products-primary quote-first">
      <p>
        <span>
          {{ $t('mEditionProductTrackingCodes.quote.firstText') }}
        </span>
        <a
          class="text-color-products-primary"
          href="https://www.facebook.com/business/help/651294705016616"
          target="_blank"
        >
          facebook
        </a>
        <span>
          {{ $t('mEditionProductTrackingCodes.quote.secondText') }}
        </span>
        <a
          class="text-color-products-primary"
          href="https://analytics.google.com/"
          target="_blank"
        >
          google analytics
        </a>
        <span>
          {{ $t('mEditionProductTrackingCodes.quote.thirdText') }}
        </span>
      </p>
    </blockquote>

    <AtomButtonSecondary
      :button-secondary="buttonSecondary.create"
      @createTrackingCode="createTrackingCode"
    />

    <div
      v-if="element.codigos_rastreo.length > 0"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionProductTrackingCodes.table.thName') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionProductTrackingCodes.table.thEdit') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionProductTrackingCodes.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="rastreo in element.codigos_rastreo"
          :key="rastreo.id_producto_codigo_rastreo"
          class="row-data"
        >
          <td class="text-align-left">
            {{ rastreo.nombre }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="rastreo"
              @editTrackingCode="editTrackingCode"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="rastreo"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductTrackingCodes',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object
  },

  data () {
    return {
      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductTrackingCodesModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductTrackingCodes.tooltip.delete'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'editTrackingCode',
          tooltip: this.$t('mEditionProductTrackingCodes.tooltip.edit'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-products-secondary',
          component: '',
          icon: 'fas fa-plus',
          method: 'createTrackingCode',
          text: this.$t('mEditionProductTrackingCodes.buttonSecondary.createText'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: this.element.codigos_rastreo.length,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: this.element.codigos_rastreo.length
      },

      showLoadingState: false
    }
  },

  methods: {
    createTrackingCode () {
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}/${this.$t('mEditionMenu.product.trackingCodes.children.create.subedition')}`)
    },

    editTrackingCode (rastreo) {
      this.$store.commit('setProductSelectedTrackingCode', rastreo)
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.trackingCodes.subject')}/${this.$t('mEditionMenu.product.trackingCodes.children.edit.subedition')}`)
    }
  }
}
</script>
